import { useState } from 'react';
import Sheet from './Sheet';
import { PRIMARY } from './CaptureSheets';
import { useApp } from '../lib/AppContext';

// Asked once, right after a new account signs in and answers self or coach (RolePicker), in the personal app: the name Apple/Google/Zalo gave is filled in to confirm or
// change (some share none, so the account starts as "Bạn mới"). Coaches, invites and notifications show it.
// Not on a coach's invite (InvitePage sets holdName): accepting it gives the name the coach chose.
const PLACEHOLDER = 'Bạn mới'; // User::PLACEHOLDER_NAME

export default function NameSheet() {
  const { api, profile, setProfile } = useApp();
  const [name, setName] = useState(profile?.name && profile.name !== PLACEHOLDER ? profile.name : '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const open = !!profile?.needsName && !profile?.holdName;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const data = await api.patch('/profile', { name: name.trim() });
      setProfile((p) => ({ ...p, name: data.name, needsName: data.needs_name }));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Sheet open={open} onClose={() => {}} dismissible={false} title="Bạn tên là gì?">
      <form className="flex flex-col gap-4" onSubmit={save}>
        <p className="text-sm text-muted">Huấn luyện viên và người bạn chia sẻ nhật ký sẽ thấy tên này. Bạn đổi được trong Hồ sơ.</p>
        <input aria-label="Tên của bạn" autoComplete="name" className="input h-12 w-full rounded-[14px] border-line text-base" maxLength={50}
          placeholder="VD: Minh Anh" value={name} onChange={(e) => setName(e.target.value)} />
        {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}
        <button type="submit" className={PRIMARY} disabled={busy || !name.trim()}>
          {busy && <span className="loading loading-spinner loading-sm" />} Tiếp tục
        </button>
      </form>
    </Sheet>
  );
}
